import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeFour/logo.png'


const _hoisted_1 = { class: "notice_container" }
const _hoisted_2 = { class: "headIcon" }
const _hoisted_3 = { class: "titleHead" }
const _hoisted_4 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'errorNotice',
  emits: ['goToHome'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const goToHome = () => {
    emits('goToHome')
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_icon, {
        name: "arrow-left",
        onClick: goToHome
      })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('notice.updateNotification')), 1),
    _createElementVNode("div", {
      innerHTML: _ctx.$t('notice.contentText')
    }, null, 8, _hoisted_4)
  ]))
}
}

})